import axios from "@/vue-axios/service.js";
import { tr } from "@/i18n";

const Authorization = ({ email, password }) => {
  return axios
    .get(
      `login?email=${encodeURIComponent(email)}&password=${encodeURIComponent(
        password
      )}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { status: false, message: error.response?.data?.message || tr("Login failed. Please try again.") };
    });
};

export default Authorization;
